import React, { useState, useEffect } from 'react';
import { db } from '../../firebase';
import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc } from 'firebase/firestore';

const ManageServices = () => {
    const [services, setServices] = useState([]);
    const [name, setName] = useState('');
    const [price, setPrice] = useState('');
    const [description, setDescription] = useState('');
    const [editingId, setEditingId] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchServices = async () => {
            setIsLoading(true);
            const servicesCollectionRef = collection(db, "services");
            const data = await getDocs(servicesCollectionRef);
            setServices(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
            setIsLoading(false);
        };

        fetchServices();
    }, []);

    const formatCurrency = (value) => {
        if (!value) return '';
        // Remove tudo que não for dígito
        let numberValue = value.toString().replace(/\D/g, '');
        if (numberValue === '') return '';
        // Formata para o padrão BRL
        numberValue = (parseInt(numberValue, 10) / 100).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
        return numberValue;
    };

    const handlePriceChange = (e) => {
        setPrice(formatCurrency(e.target.value));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const servicesCollectionRef = collection(db, "services");
        const serviceData = { name, price, description };

        if (editingId) {
            const serviceDoc = doc(db, "services", editingId);
            await updateDoc(serviceDoc, serviceData);
        } else {
            await addDoc(servicesCollectionRef, serviceData);
        }
        resetForm();
        const data = await getDocs(servicesCollectionRef);
        setServices(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };

    const handleEdit = (service) => {
        setEditingId(service.id);
        setName(service.name);
        setPrice(service.price ? formatCurrency(service.price) : '');
        setDescription(service.description);
    };

    const handleDelete = async (id) => {
        if (window.confirm("Tem certeza que deseja excluir este serviço?")) {
            const serviceDoc = doc(db, "services", id);
            await deleteDoc(serviceDoc);
            const servicesCollectionRef = collection(db, "services");
            const data = await getDocs(servicesCollectionRef);
            setServices(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
        }
    };

    const resetForm = () => {
        setEditingId(null);
        setName('');
        setPrice('');
        setDescription('');
    };

    return (
        <div className="bg-neutral-800 p-6 rounded-lg mb-8">
            <h2 className="text-xl font-bold text-white mb-4">Gerenciar Serviços</h2>
            <form onSubmit={handleSubmit} className="mb-6 space-y-4">
                <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Nome do Serviço" className="w-full p-2 bg-neutral-700 rounded" required />
                <input value={price} onChange={handlePriceChange} placeholder="Preço (opcional)" className="w-full p-2 bg-neutral-700 rounded" />
                <textarea value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Descrição" className="w-full p-2 bg-neutral-700 rounded" required />
                <div className="flex gap-2">
                    <button type="submit" className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-500">{editingId ? 'Atualizar Serviço' : 'Adicionar Serviço'}</button>
                    {editingId && <button type="button" onClick={resetForm} className="bg-gray-500 text-white px-4 py-2 rounded">Cancelar</button>}
                </div>
            </form>
            <div>
                {isLoading ? <p>Carregando serviços...</p> : services.map(service => (
                    <div key={service.id} className="flex flex-col sm:flex-row justify-between items-start sm:items-center bg-neutral-700 p-3 rounded mb-2 gap-2">
                        <span className="flex-1">{service.name} - {service.price || 'Preço a consultar'}</span>
                        <div className="flex-shrink-0 flex gap-2">
                            <button onClick={() => handleEdit(service)} className="bg-blue-600 text-white px-3 py-1 rounded">Editar</button>
                            <button onClick={() => handleDelete(service.id)} className="bg-red-600 text-white px-3 py-1 rounded">Excluir</button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ManageServices;
